var filter = function () {
    return function (phoneNumber, format) {
        var newPhoneNumber = '';
        if (angular.isDefined(phoneNumber) && (phoneNumber !== null)) {
            newPhoneNumber = phoneNumber.replace(/ |-/gi, "");
        }
        var specialChars = ["+", "-", " "];
        var newNumber = "";
        var count = 0;
        var i;
        for (i = 0; i < format.length; i++) {
            if (specialChars.indexOf(format[i]) > -1) {
                if (format[i] == newPhoneNumber[i]) {
                    newNumber = newNumber + format[i];
                    count++;
                }
                else {
                    newNumber = newNumber + format[i];
                }
            }
            else {
                if (newPhoneNumber[count]) {
                    newNumber = newNumber + newPhoneNumber[count];
                }
                count++;
            }
        }
        if (i == format.length) {
            return newNumber;
        }
    };
};
var ɵ0 = filter;
export var PhoneNumberFilter = {
    name: 'phonenumber',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-phone-number.filter.js.map